export default __webpack_public_path__ + "static/media/11_winhotel.b94aee0d.svg";